import React, { FC, useEffect, useState } from 'react';
import {
  Checkbox,
  Box,
  Text,
  Label,
  Heading,
  Input,
} from '@resideo/blueprint-react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import SeparatorLine from 'components/common/SeparatorLine';
import CustomLabel from '../../common/CustomLabel';
import { maskPhoneNumber } from 'utils/maskPhoneNumber';

const Container = styled(Box)`
  border-radius: 0.9375rem;
  border: 2px solid ${({ theme }) => theme.colors.lightenGray};
  select,
  input {
    border: 2px solid ${({ theme }) => theme.colors.primary};
    font-family: 'Roboto';
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.header.secondaryLinkActive};
  }
`;

const ModifiedCheckbox = styled(Checkbox)`
  @media (min-width: ${({ theme }) => theme.breakpoints.xSmall}) {
    margin-right: 2.75rem;
  }
`;

const ContactForm: FC<any> = ({
  values,
  setFieldValue,
  viewerData,
  fErrors,
  disableContact = false,
}) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState<string>('');

  useEffect(() => {
    setFieldValue('email', viewerData && viewerData?.contactEmail);
    if (viewerData && viewerData?.contactEmail) {
      setEmail(viewerData?.contactEmail);
    }
    setFieldValue(
      'phone',
      viewerData &&
        (viewerData?.primaryPhoneNumber ||
          viewerData?.phoneNumbers?.[0].number ||
          viewerData?.partnerUsers?.edges[0]?.node?.partnerAccount
            .primaryPhoneNumber)
    );
  }, [setFieldValue, viewerData]);

  return (
    <Container data-test-shipping-form-sections padding='1.5625rem'>
      <Text fontSize='small' paddingBottom='small' fontStyle={'italic'}>
        {t('common.requiredFields')}
      </Text>
      <Box data-test-shipping-email marginBottom='medium'>
        <CustomLabel htmlFor='email' title={`${t('cart.shipping.email')}*`} />
        <Input
          autoComplete='off'
          color={'header.secondaryLinkActive'}
          disabled={disableContact}
          placeholder='Email'
          name='email'
          value={email}
          onChange={e => {
            setFieldValue('email', e.target.value);
            setEmail(e.target.value);
          }}
        />
        <Text color='red' fontSize='small' paddingLeft='small'>
          {values.email === '' && 'Please enter an email'}
        </Text>
      </Box>
      <Box data-test-shipping-phone marginBottom='medium'>
        <CustomLabel
          htmlFor='phone'
          title={`${t('cart.shipping.phoneNumber')}*`}
        />
        <Input
          autoComplete='off'
          color={'header.secondaryLinkActive'}
          placeholder='Phone'
          disabled={disableContact}
          name='phone'
          value={maskPhoneNumber(
            values.phoneDisplay || values.phone || '',
            'ContactForm'
          )}
          onChange={e => {
            let mob = e.target.value.replace('-', '');
            if (mob.length > 3) {
              mob = mob.slice(0, 3) + '-' + mob.slice(3);
              if (mob.length > 8 && mob[7] !== '-') {
                mob = mob.slice(0, 7) + '-' + mob.slice(7);
              }
            }
            setFieldValue('phoneDisplay', mob);
            setFieldValue('phone', e.target.value);
          }}
        />
        <Text color='red' fontSize='small' paddingLeft='small'>
          {values.phone === '' && fErrors && fErrors.phone}
        </Text>
      </Box>
      <Box display='flex' marginBottom='large' alignItems='center'>
        <Label>
          <ModifiedCheckbox
            name='notified'
            marginRight='0.625rem'
            checked={values.willReceiveUpdates}
            onChange={() =>
              setFieldValue('willReceiveUpdates', !values.willReceiveUpdates)
            }
          />
        </Label>
        <Text
          fontSize='small'
          fontStyle='italic'
          color='textHeading'
          marginLeft='1rem'>
          {t('cart.shipping.subscribeText')}
        </Text>
      </Box>
      <SeparatorLine />
      <Heading letterSpacing='normal' color={'#221E1F'}>
        {t('cart.shipping.addRecipients')}
      </Heading>
      <Box
        data-test-additional-emails
        marginBottom='medium'
        paddingTop='1.5rem'>
        <CustomLabel htmlFor='emailOpt' title={`${t('cart.shipping.email')}`} />
        <Input
          autoComplete='off'
          placeholder='Additional emails'
          name='additionalEmails'
          value={
            values.additionalEmails
              ? values.additionalEmails
              : sessionStorage.getItem('temp-additional-emails') === null ||
                sessionStorage.getItem('temp-additional-emails') === ''
              ? ''
              : sessionStorage.getItem('temp-additional-emails')
          }
          onChange={e => {
            setFieldValue('additionalEmails', e.target.value);
            sessionStorage.setItem('temp-additional-emails', e.target.value);
          }}
          color={'header.secondaryLinkActive'}
        />
      </Box>
    </Container>
  );
};

export default ContactForm;
